<template>
  <div class="documents">
    <!-- <b-row v-if="add" cols="6" class="text--right">
                <b-button @click="addDoc = true" color="primary" >Ajouter</b-button>
            </b-row> -->
    <b-row v-if="documents.length == 0" class="p-15">
      Vous n'avez pas déposé de pièce pour le moment
    </b-row>

    <!-- Bouton Tout télécharger -->
    <div v-if="documents.length > 0 && card == false" class="d-flex justify-content-between align-items-center">
      <span class="text-left info-title">Documents</span>

      <b-button 
      @click="downloadAll(documents, demande)"
      class="btn btn-success"
      >
        <font-awesome-icon icon="download"></font-awesome-icon>
        Tout télécharger
      </b-button>
    </div>
    <!-- FIN Bouton Tout télécharger -->

    <b-row v-if="documents.length > 0 && card == false">

      <div class="table-documents">
        <b-row class="head-table-documents">
          <b-col cols="5" sm="5" md="5" lg="5" class="text-left col-libelle"
            >Nom</b-col
          >
          <b-col
            v-if="showLibelle"
            cols="5"
            sm="5"
            md="5"
            lg="5"
            class="text-left col-libelle"
            >Libellé</b-col
          >
          <b-col cols="2" sm="2" md="2" lg="2" class="text-right col-actions"
            >Actions</b-col
          >
        </b-row>
        <b-row v-for="doc in documents" :key="doc.name" class="liste-documents">
          <template
            v-if="
              doc.typeDocument.id != 17 &&
              doc.typeDocument.id != 20 &&
              doc.typeDocument.id != 21
            "
          >
            <b-col cols="5" sm="5" md="5" lg="5" class="col-libelle">
              <span :id="'name-doc-' + doc.id">{{ doc.name }}</span>
            </b-col>
            <b-col v-if="showLibelle" cols="5" sm="5" md="5" lg="5">
              <span class="truncat">{{ doc.typeDocument.name }}</span>
            </b-col>
            <b-col cols="2" sm="2" md="2" lg="2" class="col-actions text-right">
              <img
                style="display: none"
                :src="doc.url"
                :class="'images' + doc.id"
                v-viewer.rebuild="{ scalable: false, movable: true }"
                v-if="imageMimeType.includes(doc.mimeType)"
              />

              <b-tooltip :target="'open-document-' + doc.id" triggers="hover">
                <span>Ouvrir</span>
              </b-tooltip>
              <span :id="'open-document-' + doc.id">
                <font-awesome-icon
                  icon="eye"
                  @click="open(doc)"
                  class="pointer"
                />
              </span>

              <b-tooltip
                :target="'download-document-' + doc.id"
                triggers="hover"
              >
                <span>Télécharger</span>
              </b-tooltip>
              <span :id="'download-document-' + doc.id">
                <font-awesome-icon
                  icon="download"
                  class="ml-3 pointer"
                  @click="download(doc.url, doc.name)"
                  @click.stop
                />
              </span>

              <b-tooltip
                v-if="remove"
                :target="'remove-document-' + doc.id"
                triggers="hover"
              >
                <span>Supprimer</span>
              </b-tooltip>
              <span v-if="remove" :id="'remove-document-' + doc.id">
                <font-awesome-icon
                  icon="trash"
                  class="ml-3 pointer"
                  @click="removeDoc(doc)"
                  @click.stop
                />
              </span>
            </b-col>
          </template>
        </b-row>
      </div>
    </b-row>
    <!-- DIALOG MODALS -->
    <b-modal
      title="Visualisation du PDF"
      hide-footer
      size="xl"
      header-bg-variant="primary"
      header-text-variant="white"
      v-model="viewerPdf"
    >
      <vue-pdf-preview
        style="width: 100%"
        ref="myPdfComponent"
        :src="pdfToView"
        v-for="i in numPages"
        :key="i"
        :page="i"
      ></vue-pdf-preview>
    </b-modal>
    <b-modal
      title="Visualisation du Document"
      hide-footer
      size="xl"
      header-bg-variant="primary"
      header-text-variant="white"
      v-model="viewerDoc"
    >
      <b-card>
        <vue-doc-preview :value="docToView" type="office" />
      </b-card>
    </b-modal>
  </div>
</template>

<script>
import Vuex from "vuex";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import Vue from "vue";
import VuePdfPreview from "vue-pdf";
import VueDocPreview from "vue-doc-preview";
import saveAs from "../../node_modules/file-saver";
import JSZip from "../../node_modules/jszip";
import JSZipUtils from "../../node_modules/jszip-utils";

Vue.use(Viewer);
export default {
  components: {
    "vue-doc-preview": VueDocPreview,
    "vue-pdf-preview": VuePdfPreview,
  },
  computed: {
    ...Vuex.mapGetters("Authentification", ["userConnected"]),
  },
  data: () => ({
    docToRefuse: null,
    docToReplace: null,
    uploadProgress: false,
    error: null,
    errorMessage: null,
    doc: null,
    typeDocument: null,
    addDoc: false,
    ColCard: null,
    pdfToView: "",
    viewerPdf: false,
    viewerDoc: false,
    numPages: 1,
    dialogRefuse: false,
    docToView: "",
    ImgDoc: require("../assets/document.png"),
    ImgPdf: require("../assets/pdf.png"),
    imageMimeType: ["image/png", "image/png", "image/gif", "image/jpeg"],
    pdfMimeType: ["application/pdf"],
    DocMimeType: [
      "application/octet-stream",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "pplication/vnd.oasis.opendocument.text",
      "application/vnd.ms-powerpoint",
      "text/csv",
      "application/vnd.ms-office",
      "text/plain",
      "application/vnd.oasis.opendocument.spreadsheet",
      "application/vnd.oasis.opendocument.presentation",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    ],
  }),
  methods: {
    replaceDoc(doc) {
      this.docToReplace = doc;
      this.addDoc = true;
    },
    open(doc) {
      if (this.imageMimeType.includes(doc.mimeType)) {
        const viewer = this.$el.querySelector(".images" + doc.id).$viewer;
        viewer.show();
      } else if (this.pdfMimeType.includes(doc.mimeType)) {
        this.pdfToView = VuePdfPreview.createLoadingTask(doc.url);
        this.pdfToView.promise.then((pdf) => {
          this.numPages = pdf.numPages;
        });
        this.viewerPdf = true;
      } else if (this.DocMimeType.includes(doc.mimeType)) {
        this.viewerDoc = true;
        this.docToView = doc.url;
      }
    },
    removeDoc(doc) {
      this.$emit("removeDocument", doc);
    },
    forceFileDownload(response, name) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", name); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    download(doc, name) {
      axios({
        method: "get",
        url: doc,
        responseType: "arraybuffer",
      })
        .then((response) => {
          this.forceFileDownload(response, name);
        })
        .catch(() => console.log("error occured"));
    },
    
    downloadAll(documents, demande) {
    const zip = new JSZip();
    const zipFilename = "Documents_demande_no_" + demande.id + ".zip";
    
    const downloadPromises = documents.map(document => {
      return new Promise((resolve, reject) => {

        let url = document.url;
        if (url.startsWith('http://')) {
          url = url.replace('http://', 'https://');
        }

        JSZipUtils.getBinaryContent(url, (err, data) => {
          if (err) {
            reject(err);
          } else {
            zip.file(document.name, data, { binary: true });
            resolve();
          }
        });
      });
    });

    Promise.all(downloadPromises)
      .then(() => {
        return zip.generateAsync({ type: 'blob' });
      })
      .then(content => {
        saveAs(content, zipFilename);
      })
      .catch(err => {
        console.error("Error downloading files: ", err);
      });
    }

  },

  name: "documents",
  props: {
    /**
     * tableau des documents à passer en paramètre
     * sous form {url : '', name :'', libelle : '', valid : true}
     */
    documents: {
      type: Array,
      required: true,
      default: function () {
        return [];
      },
    },
    demande: {
      type: Object,
      required: true,
      default: function() {
        return {};
      }
    },
    //card
    card: { type: Boolean, required: true, default: true },
    // taille
    xs: { type: String, required: false, default: "2" },
    md: { type: String, required: false, default: "2" },
    lg: { type: String, required: false, default: "2" },
    xl: { type: String, required: false, default: "2" },
    sm: { type: String, required: false, default: "2" },

    //si on add ou on remove
    remove: { type: Boolean, required: false, default: false },
    add: { type: Boolean, required: false, default: false },
    replace: { type: Boolean, required: false, default: false },
    //show le libelle
    showLibelle: { type: Boolean, required: false, default: true },

    //si prop valid
    showValid: { type: Boolean, required: false, default: false },
  },
};
</script>
